import type { FunctionComponent } from 'react'
import { Variant } from '../../Button/Button'
import { useMapContext } from '../../../contexts/map/MapContext'
import Reduce from '../../../assets/icons/reduce.svg'
import Icon from '../../Icon/Icon'
import { MapButton } from '../styles'
import Enlarge from '../../../assets/icons/enlarge.svg'

const PanoramaMapMinimizeButton: FunctionComponent = () => {
  const { panoFullScreen, setPanoFullScreen } = useMapContext()

  return (
    <MapButton
      type="button"
      variant={Variant.PrimaryInverted}
      title={panoFullScreen ? 'Kaart vergroten' : 'Kaart verkleinen'}
      size={44}
      data-testid="panoramaMapMinimize"
      onClick={() => setPanoFullScreen(!panoFullScreen)}
    >
      <Icon size={40}>{panoFullScreen ? <Enlarge /> : <Reduce />}</Icon>
    </MapButton>
  )
}

export default PanoramaMapMinimizeButton
